<div class="home-wrapper">
  <app-login class="login-wrapper"></app-login>
  <app-footer class="footer-wrapper"></app-footer>
</div>
